/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LinkToShorten } from '../../models/link-to-shorten';

export interface LinkShortenerCreate$Params {

/**
 * The shortened link identifier.
 */
  link: string;
      body: LinkToShorten
}

export function linkShortenerCreate(http: HttpClient, rootUrl: string, params: LinkShortenerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, linkShortenerCreate.PATH, 'post');
  if (params) {
    rb.path('link', params.link, {});
    rb.body(params.body, '$default');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

linkShortenerCreate.PATH = '/link-shortener/{link}';
